<script>
  import { createEventDispatcher } from "svelte";
  import rangy from "rangy/lib/rangy-core.js";
  import "rangy/lib/rangy-selectionsaverestore.js";

  const dispatch = createEventDispatcher();
  export let fpText = "";
  export let key = null;
  export let showPoints = true;

  const keywords = {
    clicks: 1,
    taps: 1,
    presses: 1,
    swipes: 1,
    hovers: 1,
    types: 1,
    reads: 1,
    scrolls: 1,
    decides: 1,
    "moves mouse": 1,
    "page loads": 1,
    "modal opens": 1,
    "modal closes": 1,
    "menu opens": 1,
    "menu closes": 1,
    "popup opens": 1,
    "popup closes": 1,
  };

  $: effort = calculateFrictionPoints(fpText);

  let htmlCode = '';

  let savedSel; // Svelte reactive variable

  function calculateFrictionPoints(words) {
    var counter = 0;
    for (const property in keywords) {
      var a = occurrences(words, property);
      counter += a * keywords[property];
    }

    //look for a number followed by an s (10s, 20s, etc.) add those to the timer
    var numbers = words.match(/\d+s/g);
    var numbersTotal = 0;

    if (numbers) {
      numbers.forEach(function (n) {
        numbersTotal += parseInt(n.replace("s", ""));
      });
    }

    var fps = words.match(/\d+fp/g);
    var fpsTotal = 0;

    if (fps) {
      fps.forEach(function (n) {
        fpsTotal += parseInt(n.replace("fp", ""));
      });
    }

    counter += numbersTotal;
    counter += fpsTotal;

    dispatchMessage(counter);
    return counter;
  }

  function occurrences(string, subString, allowOverlapping) {
    string += "";
    subString += "";
    if (subString.length <= 0) return string.length + 1;

    var n = 0,
      pos = 0,
      step = allowOverlapping ? 1 : subString.length;

    while (true) {
      pos = string.indexOf(subString, pos);
      if (pos >= 0) {
        ++n;
        pos += step;
      } else break;
    }
    return n;
  }

  function dispatchMessage(value) {
    dispatch("message", { fp: value });
  }

  function handleInput(event) {
    const editor = event.target;
    savedSel = rangy.saveSelection();
    
    markWords(editor)
    rangy.restoreSelection(savedSel);
    htmlCode = editor.innerHTML; 
  }

  function handlePaste(event) {
  event.preventDefault();

  // Get the pasted text as plain text
  const text = (event.clipboardData || window.clipboardData).getData('text/plain');

  // Insert the plain text at the cursor position
  const selection = window.getSelection();
  if (selection.rangeCount > 0) {
    const range = selection.getRangeAt(0);
    range.deleteContents();
    const textNode = document.createTextNode(text);
    range.insertNode(textNode);
    range.setStartAfter(textNode);
    range.collapse(true);
    selection.removeAllRanges();
    selection.addRange(range);
  }
}


  let previousHTML = '';


  function markWords(editor) {
  const html = editor.innerHTML;
  let modifiedHtml = html.replace(/<\/?strong>/gi, "");
  const words = Object.keys(keywords);
  

  // Use a single regex to match all keywords
  const keywordRegex = new RegExp(`\\b(${words.join("|")})\\b`, "gi");
  modifiedHtml = modifiedHtml.replace(keywordRegex, "<strong>$&</strong>");

  // Match numbers with 's' and 'fp'
  const numRegex = /(\D?)(\d+(?:s|fp))/g;
  modifiedHtml = modifiedHtml.replace(numRegex, (match, prefix, group) => {
    return `${prefix}<strong>${group} </strong>`;
  });

  editor.innerHTML = modifiedHtml;
}


</script>

<div class="fp-wrapper h-full relative border-r">
  
  
  <div
    class="editable p-4 text-sm pb-12 pt-12 h-full "
    contenteditable="true"
    bind:innerHTML={fpText}
    on:input={handleInput}
    on:paste = {handlePaste}
    id="editor-{key}"      
  />

<div class="fp-display absolute top-0 border-b bg-white border-l right-0" style={effort == 0 ? "opacity:.1" : ""}>
  {#if showPoints}
    <strong>{effort}</strong><span>fp</span>
  {/if}
</div>
</div>



<style>
  .editable {    
    height: 1fr;
    width: 1fr;
    line-height: 1.5em;
    min-height: 200px;
  }

  :global(.editable strong, .hilite) {
    box-shadow: 0px 2px rgba(0, 178, 255, 1);
    background: rgba(0, 178, 255, 0.1);
    display: inline-block;
    font-weight: bold;
    color: black;
  }

  .fp-display {
    padding: 5px;
    font-size: 1.5em;
  }
  .fp-display span {
    font-weight: normal;
    font-size: 0.5em;
  }
  

  .key {
    text-transform: uppercase;
    letter-spacing: 0.2em;
    color: rgba(0, 0, 0, 0.8);
    font-size: 0.5em;
    padding: 10px;
  }
</style>
